<template>
  <div class="reset">
    <div class="container">
      <!--      <img class="got-mold-box" src="../../images/bg/bg_box.png" alt="Box" />-->
      <div class="form">
        <div class="title">
          Forgot Password
        </div>
        <div class="subtitle">
          Password must be at least 8 characters
        </div>
        <div class="input-wrap">
          <input
            type="password"
            class="input"
            placeholder="Password"
            v-model="password"
            name="password"
            v-validate="'required|min:8'"
            readonly
            onfocus="this.removeAttribute('readonly');"
          />
        </div>
        <div class="input-wrap">
          <input
            type="password"
            class="input"
            placeholder="Confirm Password"
            v-model="password_confirmation"
            name="confirmPassword"
            v-validate="{ required: true, min: 8, is: password }"
            readonly
            onfocus="this.removeAttribute('readonly');"
          />
        </div>
        <button
          class="btn"
          @click.prevent="$validator.validateAll()"
          @click="changePass"
        >
          Change Password
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "reset",
  data() {
    return {
      email: null,
      token: null,
      password: "",
      password_confirmation: ""
    };
  },
  computed: {
    isComplete() {
      return this.password_confirmation && this.password;
    }
  },
  methods: {
    ...mapActions(["changePassword"]),
    changePass() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      let data = {
        email: this.email.toLocaleLowerCase(),
        token: this.token,
        password: this.password,
        password_confirmation: this.password_confirmation
      };
      this.changePassword(data).then(res => {
        this.$router.push("/login");
      });
    }
  },
  mounted() {
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.reset {
  max-width: 100%;
  width: 100vw;
  max-height: 100%;
  height: 100vh;
  display: flex;
  background-color: transparent;
  background-size: cover;
  padding: 90px 0 0 0;
}
.form {
  padding: 36px 80px 40px 80px;
  background-color: $white;
  max-width: 500px;
  width: 50%;
  max-height: 400px;
  height: 100%;
  margin: 40px 0 0 auto;
  box-shadow: 0 3px 15px -9px $boxShadow;
  position: relative;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.title {
  color: $blue;
  font-family: TTNormsMedium, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}
.subtitle {
  color: $gray;
  font-family: TTNormsMedium, sans-serif;
  font-size: 15px;
  text-align: center;
  margin: 0 0 36px 0;
  padding: 0 5px;
}
.input.invalid {
  border: 1px solid $red;
}
.input-wrap {
  margin: 0 0 10px 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  font-family: TTNormsMedium, sans-serif;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.input:disabled {
  border: none;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 36px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
@media screen and (max-width: 1000px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
  .got-mold-box {
    bottom: 200px;
  }
}
@media screen and (max-width: 768px) {
  .reset {
    background: url("../../images/bg/sky-mobile.jpg");
  }
  .form {
    margin: 0 auto;
    width: 100%;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 20px;
  }
}
</style>
